import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { REPORTS } from "@/constants/testIds";

const PERIOD_OPTIONS = [
  { value: "today", label: "Hoy" },
  { value: "week", label: "Esta semana" },
  { value: "month", label: "Este mes" },
  { value: "year", label: "Este año" },
  { value: "custom", label: "Rango personalizado" },
];

/** Selector de periodo compartido entre el Dashboard y los Reportes de
 * negocio. Cuando el periodo es "custom" muestra dos inputs de fecha. */
export default function PeriodSelector({ value, onChange }) {
  const { period, start, end } = value;

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={REPORTS.periodSelector}>
      <Select value={period} onValueChange={(v) => onChange({ period: v, start, end })}>
        <SelectTrigger className="w-[170px] bg-white" data-testid={REPORTS.periodSelectTrigger}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {PERIOD_OPTIONS.map((o) => (
            <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      {period === "custom" && (
        <div className="flex items-center gap-2">
          <Input
            type="date" value={start || ""} max={end || undefined}
            onChange={(e) => onChange({ period, start: e.target.value, end })}
            data-testid={REPORTS.periodStartInput} className="w-[150px] bg-white"
          />
          <span className="text-muted-foreground text-sm">a</span>
          <Input
            type="date" value={end || ""} min={start || undefined}
            onChange={(e) => onChange({ period, start, end: e.target.value })}
            data-testid={REPORTS.periodEndInput} className="w-[150px] bg-white"
          />
        </div>
      )}
    </div>
  );
}
